import FeedbackEndOfTherapyPage from './FeedbackEndOfTherapyPage'

export default FeedbackEndOfTherapyPage
